module.exports = __webpack_public_path__ + "static/media/pitt-logo.442a2dfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/pitt-logo.svg
// module id = 580
// module chunks = 0